module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-regular-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-regular-webfont.eot
// module id = 94
// module chunks = d-game